import { atom, useAtomValue } from 'jotai';
import type { UserBaseAuthDTO } from 'types/user';

export const userDetailsAtom = atom<UserBaseAuthDTO | null>(null);

export const useUserDetails = () => useAtomValue(userDetailsAtom) as UserBaseAuthDTO;
